import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const QcSchedulerPage = lazy(() => import('./pages/qc-scheduler'))
const PutawayMonitoringPage = lazy(() => import('./pages/putaway-monitoring'))
const QcOperatorPage = lazy(() => import('./pages/qc-rm-operator'))
const PutawayOperatorPage = lazy(() => import('./pages/putaway-rm-operator'))
const MisplacementFixPage = lazy(() => import('./pages/misplacement-fix'))

/** Cluster C04 Inbound WH RM — IRM-04 (qc-scheduler), IRM-05 (qc-rm-operator), IRM-06 (putaway-monitoring), IRM-07 (putaway-rm-operator), IRM-08 (misplacement-fix). */
const inboundRmRoutes: RouteObject[] = [
  {
    path: 'inbound-rm',
    children: [
      { path: 'qc-scheduler', element: <QcSchedulerPage /> },
      { path: 'putaway-monitoring', element: <PutawayMonitoringPage /> },
      { path: 'qc-rm-operator', element: <QcOperatorPage /> },
      { path: 'putaway-rm-operator', element: <PutawayOperatorPage /> },
      { path: 'misplacement-fix', element: <MisplacementFixPage /> }
    ]
  }
]

export default inboundRmRoutes
